import React from 'react';
export function Footer() {
  return <footer className="py-12 md:py-16 border-t border-green-200 bg-white" data-id="element-22">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-23">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-50 border border-green-200 text-green-600 text-sm font-bold tracking-wider mb-6" data-id="element-24">
          MEGA PACK CETOSIS EXTREMA™
        </div>

        <p className="text-slate-700 font-medium text-base md:text-lg mb-2" data-id="element-25">
          El sistema keto N°1 para bajar de peso en Argentina.
        </p>
        <p className="text-slate-500 text-sm md:text-base mb-10" data-id="element-26">
          Porque hacer keto en Argentina no debería requerir ingredientes
          importados, recetas imposibles ni abandonar el asado del domingo.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm text-slate-600 mb-10" data-id="element-27">
          <a href="mailto:soporte@megapackcetosis.com" className="hover:text-green-600 transition-colors" data-id="element-28">
            📧 soporte@megapackcetosis.com
          </a>
          <span className="hidden md:inline text-green-200" data-id="element-29">|</span>
          <a href="https://www.megapackcetosis.com" target="_blank" rel="noopener noreferrer" className="hover:text-green-600 transition-colors" data-id="element-30">
            📱 @megapackcetosis
          </a>
        </div>

        <div className="text-slate-500 text-xs md:text-sm space-y-1 mb-12" data-id="element-31">
          <p data-id="element-32">
            © Mega Pack Cetosis Extrema 21 Días 2026 — Todos los derechos
            reservados.
          </p>
          <p data-id="element-33">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="pt-8 border-t border-green-200" data-id="element-34">
          <p className="text-slate-600 italic font-medium text-sm md:text-base" data-id="element-35">
            "El próximo lunes puede ser diferente." 🇦🇷
          </p>
        </div>
      </div>
    </footer>;
}